export default {
  // component: null,
  priority: 92,
  permissions: ["TimeAttendanceMenu/EditReportMenu"], // ["ReportsMenu", "DeviceListMenu", "DeviceChartMenu", "ClockingMenu", "WorkingHourMenu", "CalendarMenu"
  name: app.translate('قوانین محاسبات'),
  icon: 'settings',
  drawer: true,
  // component: load(() => import(/* webpackChunkName: "Personnel" */ './Setting')),
};
